"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = require("reactcss");

var _reactcss2 = _interopRequireDefault(_reactcss);

var _reactColor = require("react-color");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function ColorWidget(props) {
  // Note: since React 15.2.0 we can't forward unknown element attributes, so we
  // exclude the "options" and "schema" ones here.
  var value = props.value,
      options = props.options,
      schema = props.schema,
      formContext = props.formContext,
      registry = props.registry,
      inputProps = _objectWithoutProperties(props, ["value", "options", "schema", "formContext", "registry"]);

  inputProps.type = "color";
  inputProps.label = null;

  var onChangeHandler = function onChangeHandler(value) {
    var color = value.hex;
    return props.onChange(color === "" ? options.emptyValue : color);
  };

  return _react2.default.createElement(SketchExample, { value: props.value, changeHandler: onChangeHandler });
}

var SketchExample = function (_React$Component) {
  _inherits(SketchExample, _React$Component);

  function SketchExample(props) {
    _classCallCheck(this, SketchExample);

    var _this = _possibleConstructorReturn(this, (SketchExample.__proto__ || Object.getPrototypeOf(SketchExample)).call(this, props));

    _this.state = {
      displayColorPicker: false,
      color: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
      }
    };

    _this.handleClick = function () {
      _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
    };

    _this.handleClose = function () {
      _this.setState({ displayColorPicker: false });
    };

    _this.handleChange = function (color) {
      _this.setState({ color: color.rgb });
      _this.props.changeHandler(color);
    };

    _this.hexToRgbA = function (hex) {
      var c = void 0;

      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");

        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");

        return {
          r: c >> 16 & 255,
          g: c >> 8 & 255,
          b: c & 255,
          a: 1
        };
      }

      return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
      };
    };

    _this.state.color = _this.hexToRgbA(_this.props.value);
    return _this;
  }

  _createClass(SketchExample, [{
    key: "render",
    value: function render() {
      var styles = (0, _reactcss2.default)({
        default: {
          color: {
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: "rgba(\n            " + this.state.color.r + ", \n            " + this.state.color.g + ", \n            " + this.state.color.b + ",\n            " + this.state.color.a + ")"
          },
          swatch: {
            padding: "5px",
            background: "#fff",
            borderRadius: "1px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
            display: "inline-block",
            cursor: "pointer"
          },
          popover: {
            position: "absolute",
            zIndex: "2"
          },
          cover: {
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px"
          }
        }
      });

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { style: styles.swatch, onClick: this.handleClick },
          _react2.default.createElement("div", { style: styles.color })
        ),
        this.state.displayColorPicker ? _react2.default.createElement(
          "div",
          { style: styles.popover },
          _react2.default.createElement("div", { style: styles.cover, onClick: this.handleClose }),
          _react2.default.createElement(_reactColor.SketchPicker, {
            color: this.state.color,
            onChange: this.handleChange
          })
        ) : null
      );
    }
  }]);

  return SketchExample;
}(_react2.default.Component);

ColorWidget.defaultProps = {
  type: "text",
  required: false,
  disabled: false,
  readOnly: false,
  autoFocus: false
};

if (process.env.NODE_ENV !== "production") {
  ColorWidget.propTypes = {
    id: _propTypes2.default.string.isRequired,
    placeholder: _propTypes2.default.string,
    value: _propTypes2.default.any,
    required: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    readOnly: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func
  };
}

exports.default = ColorWidget;